/*
Copyright 2026 Element Creations Ltd.

SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-Element-Commercial
Please see LICENSE in the repository root for full details.
*/

import i18n from "i18next";

import type { Session } from "../ClientContext";

export class SessionHomeserverMismatch extends Error {
  constructor() {
    super(i18n.t("instance.ui.different_homeserver"));
  }
}

export function sessionHomeserver(
  session: Session,
  configuredUrl?: string,
  configuredName?: string,
): string {
  const saved = session.homeserver_url;
  if (
    !saved &&
    session.user_id.substring(session.user_id.indexOf(":") + 1) !==
      configuredName
  ) {
    throw new SessionHomeserverMismatch();
  }
  const value = saved ?? configuredUrl;
  if (!value) throw new Error(i18n.t("instance.ui.homeserver_missing"));
  const url = new URL(value);
  if (
    !["http:", "https:"].includes(url.protocol) ||
    url.username ||
    url.password ||
    url.search ||
    url.hash
  ) {
    throw new Error(i18n.t("instance.ui.homeserver_invalid"));
  }
  return url.href.replace(/\/$/, "");
}
